/**
 * @file constants.js
 * @description Core constants for Voxel Quest.
 */

export const GAME_STATES = {
    BOOTCAMP: 'BOOTCAMP',
    BOOTCAMP_COMPLETE: 'BOOTCAMP_COMPLETE',
    LOBBY: 'LOBBY',
    VAULT_ACTIVE: 'VAULT_ACTIVE', // mystery active (compat alias)
    MYSTERY_ACTIVE: 'VAULT_ACTIVE',
    PUZZLE_ACTIVE: 'PUZZLE_ACTIVE',
    VAULT_COMPLETE: 'VAULT_COMPLETE',
    MYSTERY_COMPLETE: 'VAULT_COMPLETE',
    ERROR_FEEDBACK: 'ERROR_FEEDBACK',
    TILE_FOCUSED: 'TILE_FOCUSED',
    ACTION_SUBMITTING: 'ACTION_SUBMITTING'
};

export const TILE_STATUS = {
    LOCKED: 'LOCKED',
    OPEN: 'OPEN',
    CLAIMED: 'CLAIMED',
    SOLVED: 'SOLVED'
};

export const VAULT_CONFIG = {
    GRID_SIZE: 16,
    LOCK_DURATION_MS: 300000,
    CONTRIBUTION_LIMIT: 3,
    ENERGY_MAX: 3,
    ENERGY_REGEN_MS: 90 * 60 * 1000,
    SYNDICATE_MAX: 8,
    SYNDICATE_PUBLIC_SIZE: 4,
    REFRESH_RATE_MS: 5000
};
